/**
 * Список подразделений
 */
import { Pagination } from '@n3/ng-api-common';
import { DepartmentShort } from '@n3/ng-api-common';
export class DepartmentList extends Pagination {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public items: DepartmentShort[]; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.items = [];
        if (json.items) {
          for (const i in json.items) {
            if ( json.items.hasOwnProperty( i ) ) {
                this.items.push(new DepartmentShort(json.items[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
